import { Button } from 'flowbite-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { baseUrl } from '../config';



export function PostProductionContent() {
  return (
    <div className='p-3'>
      <h3 className='font-bold pb-3'>What is post-production</h3>
      <p>
      Post-production is a critical phase in the filmmaking process where raw footage is transformed into a polished final product. This stage involves editing, color correction, 
      sound design, visual effects (VFX), and music composition, all of which help to bring the director’s vision to life.
      </p>
      <div className="mt-3">
        <p className=" font-bold">Market Analysis</p>
        <p>During post-production, filmmakers often work with marketing teams to conduct market analysis. This involves researching trends, audience preferences, and 
            industry shifts to ensure the film is positioned for success. Insights gained from 
            market analysis help identify target demographics, the best platforms for release, and potential competition, shaping how the film is marketed and distributed. 
        </p>
        <Link className="/promotions"><p>Want to know how it works?</p></Link>
      </div>
      <div className="mt-3">
        <p className=" font-bold">Promotions</p>
        <p>Once the script is finalized, producers work closely with line producers or production managers to create a detailed budget. This covers costs for actors, crew, equipment, sets, locations, special effects, and post-production.
           Securing financing and making necessary deals with investors or studios also occurs during this phase.
        </p>
        <Link className="/promotions"><p>Want to know how it works?</p></Link>
      </div>
      
      <Link to='/promotions'><p className='text-blue-600 underline mt-4 cursor-pointer'>Learn more</p></Link>
      <Link to='/post-stage' ><Button  color='dark' className="mt-4">No thanks, take me to the page</Button></Link>
    </div>
  );
}
